import { render, staticRenderFns } from "./Home_puyang.vue?vue&type=template&id=2982dee4&"
import script from "./Home_puyang.vue?vue&type=script&lang=js&"
export * from "./Home_puyang.vue?vue&type=script&lang=js&"
import style0 from "./Home_puyang.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports